import React from "react";
import "./styles.scss";
import PropTypes from "prop-types";
import { FormHeader, ImageComponent } from "..";

const Index = ({ data, onChange, onClick }) => {
  let inputElement = null;
  inputElement = (
    <>
      <div className={`initiative-card-wrapper`}>
        <ImageComponent data={{ imgUrl: data.imgUrl }} />
        <div className={"icw__header"}>
          <FormHeader
            data={{
              formHeader: data.formHeader,
              size: "sm-md",
            }}
          />
        </div>
        <div className={"icw__content"}>{data.content}</div>
      </div>
    </>
  );
  return <>{inputElement}</>;
};
Index.propTypes = {
  type: PropTypes.string,
  size: PropTypes.string,
};

Index.defaultdata = {
  type: "default",
  size: "sm",
};

export default Index;
